
import React, { Suspense } from "react";
import { pure } from 'recompose';
import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";
import MispichosHoC from "./MispichosHoC";
import "bootstrap/dist/css/bootstrap.min.css";
import 'antd/dist/antd.css';
import './components/dashboard-elements/Reset.css';
import './assets/OliverPlus.css';
import AuthService from "./utils/AuthService";

// service workers
import * as serviceWorker from './serviceWorkerRegistration';
import { Modal } from 'antd';
import Mispichoshelper from "./utils/Mispichoshelper";
import routes from "./routes";
import routesDynamic from "./routesDynamic";
import { /*filterRoutes,*/ filterRoutesMix } from "./routesDynamic";
import Loadin from "./components/componentsUI/Loading";
import { NotPage } from './404';
import BackToAdminButton from "./componentsMasterAdmin/BackToAdminButton";


const Auth = new AuthService();

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = { estaLogeado: false, searchingNew: false, mostrar: false, showModal: false, modalText: "", desactive: false, myRoutes: [] }
  }

  async componentDidMount() {
    this.processServiceWorkers();
    var logeado = await Auth.loggedIn();

    // Obtener rutas si estas logueado
    if (logeado) {
      await this.getMyRoutes();
    } else {
      this.setState({ estaLogeado: logeado, mostrar: true }, this.postLoggedCheck);
    }
  }

  getMyRoutes = async () => {
    Mispichoshelper.getRoutes().then((response) => {
      console.log("response!!!!", response);
      if (response !== undefined && response.status) {

        let myRoutes = response.payload;
        this.setState({
          myRoutes: myRoutes,
          estaLogeado: true,
          mostrar: true
        }, () => this.postLoggedCheck());
      } else {
        Auth.logout();
        window.location.reload()
        return <Redirect to="/login" />
      }
    }).catch((err) => {
      Auth.logout();
      window.location.reload()
      return <Redirect to="/login" />
    });

  }

  postLoggedCheck = () => {
    if (this.state.estaLogeado && (Auth.isProfile('proveedor') || Auth.isProfile('empresa logistica'))) {
      this.createZohoASAP();
      this.checkConsoleOpened();
    }
  }

  createZohoASAP = () => {
    /*
    // Documento
    var s = document.createElement('script');
    s.type = 'text/javascript';
    const script = document.createElement("script");
    script.src = "https://desk.zoho.com/portal/api/web/inapp/144130000005520073?orgId=632382603";
    */

    // Chat
    let script = document.createElement("script");
    script.type = 'text/javascript';
    script.id = 'zsiqchat';
    let script_text = document.createTextNode('var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "0f35a08c661f99647697d747fa7fd44116e98fb94940ed81079de240d93889b7", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);');
    script.appendChild(script_text)

    document.body.appendChild(script);
  }

  checkConsoleOpened = () => {
    //dev open check
    var element = new Image();
    var alreadySent = false;
    var devtoolsOpen = false;
    element.__defineGetter__("id", function () {
      devtoolsOpen = true; // This only executes when devtools is open.
    });
    // postLoggedCheck() can run more than once per session, so keep the handle and clear
    // any previous timer instead of stacking a new one each time.
    if (this.consoleCheckIntervalId) {
      clearInterval(this.consoleCheckIntervalId);
    }
    this.consoleCheckIntervalId = setInterval(function () {
      //console.log(element);
      if (devtoolsOpen && !alreadySent) {
        alreadySent = true;
        Mispichoshelper.Petshop.alertConsoleOpen();
      }
    }, 5000);

    //dev open end check
  }

  componentWillUnmount() {
    if (this.consoleCheckIntervalId) {
      clearInterval(this.consoleCheckIntervalId);
      this.consoleCheckIntervalId = null;
    }
  }

  // Cache of the per-route wrapper components.
  //
  // WHY: `MispichosHoC((props) => ...)` used to be called INLINE inside render(). Every
  // call returns a brand-new class, i.e. a new React component TYPE. PrivateRoute is
  // recompose `pure`, so a new `component` prop identity re-renders it, and React then
  // sees a different element type at that position and TEARS DOWN the entire matched
  // subtree — the layout included — and mounts a fresh one. Each remount of
  // layouts/Lienzo.js -> <CentralNotification/> registered another 120s polling interval
  // that nothing ever disposed of.
  //
  // Caching by route keeps the type referentially stable across App re-renders, so the
  // subtree is no longer destroyed and rebuilt on every setState.
  routeComponentCache = new Map();

  getRouteComponent = (route) => {
    const cached = this.routeComponentCache.get(route.path);
    // Revalidate against the captured layout/component: dynamic-role routes are rebuilt as
    // fresh objects on each filterRoutesMix() call, so a path must never serve a wrapper
    // that closes over a different view.
    if (cached && cached.layout === route.layout && cached.component === route.component) {
      return cached.wrapped;
    }

    const Layout = route.layout;
    const View = route.component;
    const wrapped = MispichosHoC(() => {
      return (
        <Layout>
          <BackToAdminButton />
          <View loginUser={this.loginUser} />
        </Layout>
      );
    });

    this.routeComponentCache.set(route.path, {
      layout: route.layout,
      component: route.component,
      wrapped,
    });
    return wrapped;
  }

  registerServiceWorker = () => {
    // Si es correcto, lanzamos una notificación
    console.log('registerService en App.js');
    serviceWorker.register();
  }

  processServiceWorkers() {

    // Comprobamos si el navegador soporta las notificaciones
    if (!("Notification" in window)) {
      alert("Este navegador no es compatible con las notificaciones de escritorio");
    }

    // Comprobamos si los permisos han sido concedidos anteriormente
    else if (Notification.permission === "granted") {
      this.registerServiceWorker();
    }

    // Si no, pedimos permiso para la notificación
    else if (Notification.permission !== 'denied' || Notification.permission === "default") {
      //console.log('preguntar')
      this.setState({ showModal: true, modalText: "Las Notificaciones nos ayudan a mantenerte informado por favor activalas!!!" })
    }

    else if (Notification.permission === 'denied') {
      this.setState({ showModal: true, desactive: true, modalText: "Notamos que tienes las notificaciones desactivadas, nos ayudan a mantenerte informado por favor activalas!!!" })
    }
  }

  askPermission = () => {
    let comp = this;

    // Si viene por msj Desactivado
    if (this.state.desactive) {
      this.setState({ showModal: false, desactive: false, modalText: "" });
      return
    }

    // Si no, pedimos permiso para la notificación
    Notification.requestPermission(function (permission) {
      // Si el usuario nos lo concede, creamos la notificación
      if (permission === "granted") {
        //serviceWorker.register();
      }
      comp.setState({ showModal: false })
    });
  }

  loginUser = () => {
    this.registerServiceWorker()
  }

  render() {


    var routesByRol = routesDynamic.publicRoutes;
    if (!this.state.mostrar) {
      return (<Loadin fullHeight={true} />)
    } else if (this.state.estaLogeado) {
      routesByRol = filterRoutesMix(routesDynamic, routes, this.state.myRoutes);
    }

    return (
      <Router basename={process.env.REACT_APP_BASENAME || ""} >
        <Suspense fallback={<Loadin fullHeight={true} />}>
          <Switch>
            {routesByRol.map((route, index) => {
              return route.path &&
                <PrivateRoute
                  estaLogeado={this.state.estaLogeado}
                  loginUser={this.loginUser}
                  key={index}
                  path={route.path}
                  publicRoute={route.public}
                  exact={route.exact}
                  component={this.getRouteComponent(route)}
                />
            }
            )}

            {/* `render` rather than `component`: an inline arrow passed to `component` is a
                new component TYPE on every render, which remounts this branch each time.
                With `render` the returned element type is stable. */}
            <Route render={() => { return (this.state.estaLogeado ? <NotFoundPage /> : <Redirect to={`/login?noMatch=true&logged=false`} />) }} />
          </Switch>
          <ServiceWorkerPermission showModal={this.state.showModal} askPermission={this.askPermission} modalText={this.state.modalText} />
        </Suspense>

      </Router>)

  }
}

const ServiceWorkerPermission = ({ showModal, askPermission, modalText }) => (
  <Modal
    title="Importante!"
    visible={showModal}
    onOk={() => { askPermission() }}
    okText="OK"
    cancelButtonProps={{ style: { display: 'none' } }}
  >
    <p>{modalText}</p>
  </Modal>
)

const NotFoundPage = () => {
  return (<NotPage />)
}



const PrivateRoute = pure(({ component: Component, publicRoute, loginUser, estaLogeado, ...rest }) => (
  (publicRoute === true || (publicRoute !== true && estaLogeado === true))
    ? <Route {...rest} render={(props) => (<Component  {...props} />)} />
    : <Redirect to={`/login?publicRoute=${publicRoute}&logged=${estaLogeado}`} />
))

export default (App);
